/**
 * 🔑 POLÍTICA DE CONTRASEÑAS DEL PANEL
 *
 * Una sola regla para el alta, la edición de un usuario y el cambio de la
 * propia contraseña. Antes estaba escrita a mano en `UsersList` (8 caracteres,
 * mayúscula, minúscula y número) y en la Configuración pedía solo 6, así que
 * según por dónde entrara una contraseña valía o no.
 *
 * ⚠️ Gemela de `problemaDeContrasena` en
 * `IGNIA-backend/server/services/credencialesUsuario.js`, que la vuelve a
 * aplicar al cambiar la contraseña de otra cuenta, y en la APK
 * (`Apk formularios/shared/…/data/ReglasSesion.kt`, la que usan Android e iOS
 * al cambiar la propia): **se cambian las tres juntas**, o una dará por buena
 * una contraseña que otra rechaza.
 *
 * @returns {string} el motivo por el que no vale, o '' si vale
 */
export function problemaDeContrasena(password) {
  if (typeof password !== 'string' || !password.trim()) return 'La contraseña es obligatoria.';
  if (password.length < 8) return 'Mínimo 8 caracteres.';
  if (!/[A-Z]/.test(password)) return 'Debe tener una mayúscula.';
  if (!/[a-z]/.test(password)) return 'Debe tener una minúscula.';
  if (!/[0-9]/.test(password)) return 'Debe tener un número.';
  return '';
}
